import * as i0 from '@angular/core';
import { Component, Input, EventEmitter, Output, HostListener, SimpleChange, Directive, ContentChild, HostBinding, ElementRef, ViewEncapsulation, Inject, Injectable, ViewChild, ViewChildren, NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule, DOCUMENT, APP_BASE_HREF } from '@angular/common';
import { ElementIssueEvent, BindingValueChangedEvent, dashboardElements, PropertyChangeEvent, HelpSystemEvent, PropertyStructureChangeEvent, AddBindingDialogEvent, RemoveBindingFromPropertyEvent, GridTileChangeEvent, Describe, AngularDashboardElement, angularDefinitionProviders, angularDashboardElementComponents, angularPropertiesComponents } from '@sick-curie/dashboard-builder-ui-models';
import { Subject, filter, merge, share, fromEvent, BehaviorSubject, combineLatest, map as map$1, tap, debounceTime as debounceTime$1, takeUntil, distinctUntilChanged, throttleTime, asyncScheduler, switchMap, interval, EMPTY, defer, forkJoin, take, of } from 'rxjs';
import { scan, map, startWith, debounceTime, takeUntil as takeUntil$1, tap as tap$1, finalize, mergeMap, isEmpty, delayWhen, repeat, withLatestFrom, switchMap as switchMap$1, catchError, retryWhen, delay, concatWith } from 'rxjs/operators';
import { TextField, TextArea, Checkbox, NumericField, DropDown, ToggleGroup, html } from '@sick-davinci/basic-elements';
import { __decorate, __metadata } from 'tslib';
import * as i1$1 from '@angular/material/snack-bar';
import { MAT_SNACK_BAR_DATA, MatSnackBarModule } from '@angular/material/snack-bar';
import { animation, style, animate, trigger, transition, useAnimation } from '@angular/animations';
import * as i1$2 from '@angular/platform-browser';
import { DEFAULT_PALLETE, DashboardPermission } from '@sick-curie/dashboard-builder-models';
import { createCustomElement } from '@angular/elements';
import { merge as merge$1, kebabCase } from 'lodash-es';

class BadgeComponent {
    constructor() {
        this.type = 'info';
        this.round = true;
        this.center = true;
    }
}
BadgeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: BadgeComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BadgeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: BadgeComponent, selector: "dashboard-builder-badge", inputs: { type: "type", round: "round", center: "center" }, ngImport: i0, template: "<div [class]=\"'badge type-' + type\" [ngClass]=\"{ round, center }\">\n  <ng-content></ng-content>\n</div>\n", styles: [".badge{display:inline-block;padding:0 1em;font-size:.65em;line-height:2em;color:var(--davinci-color-text-on-information-light,#2C3133)}.badge.type-info{background:var(--davinci-color-information-light,#e5f1f8)}.badge.round{border-radius:1em}.badge.center{transform:translateY(-.125em)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: BadgeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dashboard-builder-badge', template: "<div [class]=\"'badge type-' + type\" [ngClass]=\"{ round, center }\">\n  <ng-content></ng-content>\n</div>\n", styles: [".badge{display:inline-block;padding:0 1em;font-size:.65em;line-height:2em;color:var(--davinci-color-text-on-information-light,#2C3133)}.badge.type-info{background:var(--davinci-color-information-light,#e5f1f8)}.badge.round{border-radius:1em}.badge.center{transform:translateY(-.125em)}\n"] }]
        }], propDecorators: { type: [{
                type: Input
            }], round: [{
                type: Input
            }], center: [{
                type: Input
            }] } });

class BindingExecutionResultComponent {
    constructor() {
        this.providesValidData = new EventEmitter();
        this.value$ = new Subject();
        this.issues$ = new Subject();
        this.resetState$ = new Subject();
        this.errors$ = this.issues$.pipe(filter((issue) => issue.severity === 'error'), scan((acc, issue) => issue.resolved ? acc.filter((accIssue) => accIssue.message !== issue.message) : [issue].concat(acc), new Array()), map((issues) => issues[0]), filter((error) => error !== undefined));
        this.bindingState$ = merge(this.value$.pipe(map((value) => ({ type: 'data', value }))), this.errors$.pipe(map((error) => ({ type: 'error', message: error.message, details: error.details }))), this.resetState$.pipe(map(() => ({ type: 'waiting' })))).pipe(startWith({ type: 'waiting' }), debounceTime(100), share());
        this.bindingState$
            .pipe(map((state) => state.type === 'data'))
            .subscribe((hasValidData) => this.providesValidData.emit(hasValidData));
    }
    set reset(any) {
        this.resetState$.next();
    }
    onElementIssue($event) {
        $event.stopPropagation();
        this.issues$.next($event.detail.issue);
    }
    onBindingValueChanged($event) {
        $event.stopPropagation();
        this.value$.next($event.detail.value);
    }
}
BindingExecutionResultComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: BindingExecutionResultComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
BindingExecutionResultComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: BindingExecutionResultComponent, selector: "dashboard-builder-binding-execution-result", inputs: { reset: "reset" }, outputs: { providesValidData: "providesValidData" }, host: { listeners: { "elementError": "onElementIssue($event)", "bindingValueChanged": "onBindingValueChanged($event)" } }, ngImport: i0, template: "<div *ngIf=\"bindingState$ | async as state\" class=\"execution-output\">\n  <div class=\"label\">Result</div>\n  <div class=\"result\">\n    <davinci-spinner *ngIf=\"state.type === 'waiting'\" right label=\"Waiting for data...\"></davinci-spinner>\n    <code *ngIf=\"state.type === 'data'; else functionError\">\n      <pre>{{ state.value | json }}</pre>\n    </code>\n    <ng-template #functionError>\n      <davinci-callout type=\"warning\" *ngIf=\"state.type === 'error'\"\n        >{{ state.message }}<br />{{ state.details }}</davinci-callout\n      >\n    </ng-template>\n  </div>\n</div>\n<ng-content property=\"value\"></ng-content>\n", styles: [".execution-output .result{height:80px;margin-right:15px;overflow-y:auto}.execution-output code,.execution-output davinci-spinner,.execution-output davinci-callout{display:block}.execution-output code{padding:0 15px;background-color:var(--davinci-color-background-2,#FBFCFC);border:1px dashed #aaa}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }, { kind: "pipe", type: i1.JsonPipe, name: "json" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: BindingExecutionResultComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dashboard-builder-binding-execution-result', template: "<div *ngIf=\"bindingState$ | async as state\" class=\"execution-output\">\n  <div class=\"label\">Result</div>\n  <div class=\"result\">\n    <davinci-spinner *ngIf=\"state.type === 'waiting'\" right label=\"Waiting for data...\"></davinci-spinner>\n    <code *ngIf=\"state.type === 'data'; else functionError\">\n      <pre>{{ state.value | json }}</pre>\n    </code>\n    <ng-template #functionError>\n      <davinci-callout type=\"warning\" *ngIf=\"state.type === 'error'\"\n        >{{ state.message }}<br />{{ state.details }}</davinci-callout\n      >\n    </ng-template>\n  </div>\n</div>\n<ng-content property=\"value\"></ng-content>\n", styles: [".execution-output .result{height:80px;margin-right:15px;overflow-y:auto}.execution-output code,.execution-output davinci-spinner,.execution-output davinci-callout{display:block}.execution-output code{padding:0 15px;background-color:var(--davinci-color-background-2,#FBFCFC);border:1px dashed #aaa}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { reset: [{
                type: Input
            }], providesValidData: [{
                type: Output
            }], onElementIssue: [{
                type: HostListener,
                args: [ElementIssueEvent.TYPE, ['$event']]
            }], onBindingValueChanged: [{
                type: HostListener,
                args: [BindingValueChangedEvent.TYPE, ['$event']]
            }] } });

class ElementPropertyLinkingDirective {
    constructor(element) {
        this.element = element;
        this.linkToIndex = undefined;
        this.currentValueChange = new EventEmitter();
        const { nativeElement } = this.element;
        nativeElement.addEventListener('change', (event) => {
            this.newValue(event.detail);
        });
        if (nativeElement instanceof TextField || nativeElement instanceof TextArea) {
            fromEvent(nativeElement, 'input')
                .pipe(debounceTime(200))
                .subscribe((event) => {
                this.newValue(event.detail);
            });
        }
    }
    get currentValue() {
        return this._value;
    }
    set currentValue(value) {
        this.newValue(value);
    }
    newValue(newValue) {
        const property = dashboardElements.getProperty(this.linkToElement.tag, this.linkToProperty);
        if (!property) {
            throw new Error('Unknown property ' + this.linkToProperty);
        }
        let value = newValue;
        switch (!!property) {
            case property.type === 'number':
                value = Number(value);
                break;
            case property.type === 'number[]' && this.linkToIndex === undefined && !Array.isArray(value):
            case property.type === 'number[][]' && this.linkToIndex !== undefined && !Array.isArray(value):
                value = value
                    .split(',')
                    .map((v) => v.trim())
                    .map(Number);
                break;
            case property.type === 'string[]' && this.linkToIndex === undefined && !Array.isArray(value):
            case property.type === 'string[][]' && this.linkToIndex !== undefined && !Array.isArray(value):
                value = value
                    .split(',')
                    .map((v) => v.trim())
                    .filter(Boolean);
                break;
            default:
                break;
        }
        this._value = value;
        this.currentValueChange.emit(this._value);
        this.element.nativeElement.dispatchEvent(new PropertyChangeEvent(this.linkToProperty, this.linkToIndex, value));
    }
    ngOnChanges(changes) {
        if ((changes.linkToIndex || changes.linkToElement) && this.linkToElement) {
            const e = this.element.nativeElement;
            setTimeout(() => {
                const property = dashboardElements.getProperty(this.linkToElement.tag, this.linkToProperty);
                let value = this.linkToElement.properties[this.linkToProperty] ?? property?.defaultValue;
                if (this.linkToIndex !== undefined && value !== undefined) {
                    value = value[this.linkToIndex];
                }
                if (e instanceof Checkbox) {
                    e.checked = value;
                }
                else if (e instanceof TextField ||
                    e instanceof NumericField ||
                    e instanceof DropDown ||
                    e instanceof TextArea ||
                    e instanceof ToggleGroup) {
                    e.value = value;
                }
                this.newValue(value);
            });
        }
    }
    triggerChanges(newValue) {
        this.ngOnChanges({ linkToElement: new SimpleChange('', newValue, false) });
    }
}
ElementPropertyLinkingDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ElementPropertyLinkingDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
ElementPropertyLinkingDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.0", type: ElementPropertyLinkingDirective, selector: "[linkToElement][linkToProperty]", inputs: { linkToElement: "linkToElement", linkToProperty: "linkToProperty", linkToIndex: "linkToIndex", currentValue: "currentValue" }, outputs: { currentValueChange: "currentValueChange" }, exportAs: ["propertyLink"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ElementPropertyLinkingDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[linkToElement][linkToProperty]',
                    exportAs: 'propertyLink',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { linkToElement: [{
                type: Input
            }], linkToProperty: [{
                type: Input
            }], linkToIndex: [{
                type: Input
            }], currentValueChange: [{
                type: Output
            }], currentValue: [{
                type: Input
            }] } });

class HelpStateComponent {
    constructor(elementRef, renderer) {
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.hPos = 'left';
        this.vPos = 'top';
    }
    ngOnInit() {
        if (this.element && this.property) {
            const property = dashboardElements.getProperty(this.element.tag, this.property);
            if (property) {
                this.helptext = property.description;
            }
        }
    }
    ngAfterViewInit() {
        const dialog = this.elementRef.nativeElement.closest('dashboard-builder-modal-dialog');
        if (dialog) {
            dialog.addEventListener(HelpSystemEvent.TYPE, (event) => {
                if (event.detail.show) {
                    this.renderer.addClass(this.elementRef.nativeElement, 'is-visible');
                }
                else {
                    this.renderer.removeClass(this.elementRef.nativeElement, 'is-visible');
                }
            });
            const helpTriggerIcon = dialog.querySelector('.dashboard-builder-modal-dialog-help');
            if (helpTriggerIcon) {
                helpTriggerIcon.classList.add('is-visible');
            }
        }
    }
}
HelpStateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: HelpStateComponent, deps: [{ token: i0.ElementRef }, { token: i0.Renderer2 }], target: i0.ɵɵFactoryTarget.Component });
HelpStateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: HelpStateComponent, selector: "[helptext]", inputs: { element: "element", property: "property", helptext: "helptext", hPos: "hPos", vPos: "vPos" }, ngImport: i0, template: "<ng-content></ng-content>\n<div class=\"help-overlay-icon\" [class]=\"hPos + ' ' + vPos\" [attr.data-title]=\"helptext\">?</div>\n", styles: [":host{display:inline-flex;align-items:center;position:relative}:host.is-visible .help-overlay-icon{visibility:visible}:host .help-overlay-icon{z-index:23;color:#fff;font-family:Arial,Helvetica,sans-serif;background:rgba(243,146,0,.8);position:absolute;top:-7px;bottom:0;text-align:center;font-size:12px;font-weight:400;line-height:14px;width:16px;height:16px;border-radius:8px;right:7px;display:flex;flex-wrap:nowrap;align-items:center;justify-content:center;-webkit-user-select:none;user-select:none;visibility:hidden}:host .help-overlay-icon:hover:after{box-shadow:0 0 5px #0000004d;background:#fef9e7;border:1px solid #f5a833;border-radius:3px;bottom:26px;color:#000;content:attr(data-title);left:-5px;padding:6px;position:absolute;text-align:left;width:max-content;max-width:200px;z-index:98}:host .help-overlay-icon:hover:before{border:solid;border-color:#f5a833 transparent;border-width:6px 6px 0 6px;bottom:20px;content:\"\";left:3px;position:absolute;z-index:99}:host .help-overlay-icon:hover.right:after{left:auto;right:-5px}:host .help-overlay-icon:hover.bottom:before{bottom:-10px;transform:rotate(180deg)}:host .help-overlay-icon:hover.bottom:after{bottom:0;transform:translateY(calc(100% + 10px))}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: HelpStateComponent, decorators: [{
            type: Component,
            args: [{ selector: '[helptext]', template: "<ng-content></ng-content>\n<div class=\"help-overlay-icon\" [class]=\"hPos + ' ' + vPos\" [attr.data-title]=\"helptext\">?</div>\n", styles: [":host{display:inline-flex;align-items:center;position:relative}:host.is-visible .help-overlay-icon{visibility:visible}:host .help-overlay-icon{z-index:23;color:#fff;font-family:Arial,Helvetica,sans-serif;background:rgba(243,146,0,.8);position:absolute;top:-7px;bottom:0;text-align:center;font-size:12px;font-weight:400;line-height:14px;width:16px;height:16px;border-radius:8px;right:7px;display:flex;flex-wrap:nowrap;align-items:center;justify-content:center;-webkit-user-select:none;user-select:none;visibility:hidden}:host .help-overlay-icon:hover:after{box-shadow:0 0 5px #0000004d;background:#fef9e7;border:1px solid #f5a833;border-radius:3px;bottom:26px;color:#000;content:attr(data-title);left:-5px;padding:6px;position:absolute;text-align:left;width:max-content;max-width:200px;z-index:98}:host .help-overlay-icon:hover:before{border:solid;border-color:#f5a833 transparent;border-width:6px 6px 0 6px;bottom:20px;content:\"\";left:3px;position:absolute;z-index:99}:host .help-overlay-icon:hover.right:after{left:auto;right:-5px}:host .help-overlay-icon:hover.bottom:before{bottom:-10px;transform:rotate(180deg)}:host .help-overlay-icon:hover.bottom:after{bottom:0;transform:translateY(calc(100% + 10px))}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i0.Renderer2 }]; }, propDecorators: { element: [{
                type: Input
            }], property: [{
                type: Input
            }], helptext: [{
                type: Input
            }], hPos: [{
                type: Input
            }], vPos: [{
                type: Input
            }] } });

class BindingStateComponent {
    constructor(el) {
        this.el = el;
        this.bound = false;
        this.helpTooltipVPos = 'top';
        this.handleStructureChange = (ev) => {
            if (this.bound && ev.detail.some((d) => d.type === 'remove' && d.index === this.linkToIndex)) {
                this.bound = false;
            }
        };
    }
    ngAfterContentInit() {
        this.linkToElement = this.propertyLink?.linkToElement;
        this.linkToProperty = this.propertyLink?.linkToProperty;
        this.linkToIndex = this.propertyLink?.linkToIndex;
        this.isMandatory = dashboardElements.getProperty(this.linkToElement?.tag, this.linkToProperty)?.mandatory ?? false;
        this.helpText = this.isMandatory
            ? 'This binding is mandatory, click to open the binding dialog and set the binding for this attribute.'
            : 'Click to open the binding dialog and set the binding for this attribute.';
        this.el.nativeElement
            .closest('dashboard-builder-add-relation')
            ?.addEventListener(PropertyStructureChangeEvent.TYPE, this.handleStructureChange);
    }
    ngOnDestroy() {
        this.el.nativeElement
            .closest('dashboard-builder-add-relation')
            ?.removeEventListener(PropertyStructureChangeEvent.TYPE, this.handleStructureChange);
    }
    bindingDialogClicked() {
        this.el.nativeElement.dispatchEvent(new AddBindingDialogEvent({ name: this.linkToProperty, index: this.linkToIndex }));
    }
    overlayClosed() {
        this.bound = false;
        this.el.nativeElement.dispatchEvent(new RemoveBindingFromPropertyEvent({ name: this.linkToProperty, index: this.linkToIndex }));
    }
}
BindingStateComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: BindingStateComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
BindingStateComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: BindingStateComponent, selector: "dashboard-builder-bindable", inputs: { bound: "bound", overlayText: "overlayText", helpTooltipVPos: "helpTooltipVPos" }, host: { properties: { "class.is-selected": "this.bound" } }, queries: [{ propertyName: "propertyLink", first: true, predicate: ElementPropertyLinkingDirective, descendants: true, read: ElementPropertyLinkingDirective }], ngImport: i0, template: "<ng-content></ng-content>\n\n<div class=\"icon-wrapper\" [helptext]=\"helpText\" hPos=\"right\" [vPos]=\"helpTooltipVPos\">\n  <davinci-icon\n    icon=\"action/settings\"\n    class=\"icon unbound binding-icon\"\n    [class.mandatory]=\"isMandatory\"\n    (click)=\"bindingDialogClicked()\"\n  >\n  </davinci-icon>\n</div>\n<div class=\"binding-overlay\">\n  <davinci-icon\n    icon=\"action/settings\"\n    class=\"icon bound\"\n    title=\"Edit binding\"\n    (click)=\"bindingDialogClicked()\"\n  ></davinci-icon>\n  <div class=\"binding-text\" [title]=\"overlayText\">{{ overlayText }}</div>\n  <davinci-icon icon=\"navigation/close\" class=\"icon\" title=\"Delete binding\" (click)=\"overlayClosed()\"></davinci-icon>\n</div>\n", styles: [":host{display:inline-flex;align-items:center;position:relative}:host>.help-wrapper .help-overlay-icon{right:-30px}:host.is-selected>.help-wrapper .help-overlay-icon{right:unset;left:30px}:host.is-selected .binding-overlay{visibility:visible}:host.is-selected .binding-icon{visibility:hidden}:host.is-selected .icon-wrapper{display:none}:host .binding-overlay{z-index:20;position:absolute;background-color:var(--davinci-color-information-light,#e5f1f8);border:1px solid #bcc7cd;top:0;bottom:0;left:0;right:0;visibility:hidden;display:flex;flex-wrap:nowrap;align-items:center}:host .binding-overlay .binding-text{flex-grow:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-left:5px;color:var(--davinci-color-text-on-information-light,#2C3133)}:host .icon-wrapper{position:absolute;top:0;right:-36px;display:flex;height:100%;margin-left:auto;width:36px}:host .icon{cursor:pointer;fill:#6a7a88;margin:auto 5px}:host .icon.mandatory{fill:#f39200}:host .icon.bound{fill:#007cc1!important}:host .icon.unbound{margin:auto}\n"], dependencies: [{ kind: "component", type: HelpStateComponent, selector: "[helptext]", inputs: ["element", "property", "helptext", "hPos", "vPos"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: BindingStateComponent, decorators: [{
            type: Component,
            args: [{ selector: `dashboard-builder-bindable`, template: "<ng-content></ng-content>\n\n<div class=\"icon-wrapper\" [helptext]=\"helpText\" hPos=\"right\" [vPos]=\"helpTooltipVPos\">\n  <davinci-icon\n    icon=\"action/settings\"\n    class=\"icon unbound binding-icon\"\n    [class.mandatory]=\"isMandatory\"\n    (click)=\"bindingDialogClicked()\"\n  >\n  </davinci-icon>\n</div>\n<div class=\"binding-overlay\">\n  <davinci-icon\n    icon=\"action/settings\"\n    class=\"icon bound\"\n    title=\"Edit binding\"\n    (click)=\"bindingDialogClicked()\"\n  ></davinci-icon>\n  <div class=\"binding-text\" [title]=\"overlayText\">{{ overlayText }}</div>\n  <davinci-icon icon=\"navigation/close\" class=\"icon\" title=\"Delete binding\" (click)=\"overlayClosed()\"></davinci-icon>\n</div>\n", styles: [":host{display:inline-flex;align-items:center;position:relative}:host>.help-wrapper .help-overlay-icon{right:-30px}:host.is-selected>.help-wrapper .help-overlay-icon{right:unset;left:30px}:host.is-selected .binding-overlay{visibility:visible}:host.is-selected .binding-icon{visibility:hidden}:host.is-selected .icon-wrapper{display:none}:host .binding-overlay{z-index:20;position:absolute;background-color:var(--davinci-color-information-light,#e5f1f8);border:1px solid #bcc7cd;top:0;bottom:0;left:0;right:0;visibility:hidden;display:flex;flex-wrap:nowrap;align-items:center}:host .binding-overlay .binding-text{flex-grow:1;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;padding-left:5px;color:var(--davinci-color-text-on-information-light,#2C3133)}:host .icon-wrapper{position:absolute;top:0;right:-36px;display:flex;height:100%;margin-left:auto;width:36px}:host .icon{cursor:pointer;fill:#6a7a88;margin:auto 5px}:host .icon.mandatory{fill:#f39200}:host .icon.bound{fill:#007cc1!important}:host .icon.unbound{margin:auto}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { propertyLink: [{
                type: ContentChild,
                args: [ElementPropertyLinkingDirective, { read: ElementPropertyLinkingDirective }]
            }], bound: [{
                type: HostBinding,
                args: ['class.is-selected']
            }, {
                type: Input
            }], overlayText: [{
                type: Input
            }], helpTooltipVPos: [{
                type: Input
            }] } });

const renderListItem = (label, searchTerm) => {
    const startIndex = label.toLowerCase().indexOf(searchTerm.toLowerCase());
    if (startIndex < 0) {
        return undefined;
    }
    const endIndex = startIndex + searchTerm.length;
    const start = label.substring(0, startIndex);
    const bold = label.substring(startIndex, endIndex);
    const end = label.substring(endIndex);
    return html `<span>${start}</span><span style="font-weight: bold;">${bold}</span><span>${end}</span>`;
};

class DropDownSearchableComponent {
    constructor() {
        this.loading = false;
        this.disabled = false;
        this.clearable = false;
        this.searchTermChanged = new EventEmitter();
        this.valueChanged = new EventEmitter();
        this.searchTerm$ = new BehaviorSubject(undefined);
        this.teardown$ = new Subject();
        this.options$ = new BehaviorSubject([]);
        this.fieldOptions$ = combineLatest([this.options$, this.searchTerm$]).pipe(map$1(([options, searchTerm]) => searchTerm && Array.isArray(options)
            ? DropDownSearchableComponent.filterOptionsBySearchTerm(options, searchTerm)
            : options));
        this.contentRenderer = (_value, label) => renderListItem(label, this.searchTerm$.value ?? '');
    }
    static filterOptionsBySearchTerm(options, searchTerm) {
        const searchTermLC = searchTerm.toLocaleLowerCase();
        return options
            .map((option) => {
            if (typeof option === 'string' || !('data' in option)) {
                return DropDownSearchableComponent.simpleOptionMatchesSearchTerm(option, searchTermLC) ? option : undefined;
            }
            const matchingOptionValues = option.data.filter((optionValue) => DropDownSearchableComponent.simpleOptionMatchesSearchTerm(optionValue, searchTermLC));
            return matchingOptionValues.length > 0 ? { ...option, data: matchingOptionValues } : undefined;
        })
            .filter(Boolean);
    }
    static simpleOptionMatchesSearchTerm(option, searchTermLC) {
        const optionLabel = typeof option === 'string' ? option : option.label;
        return optionLabel.toLocaleLowerCase().includes(searchTermLC);
    }
    static findOption(options, pickSearched, isMatch) {
        for (const option of options) {
            if (typeof option !== 'string' && 'data' in option) {
                const inOptGroup = DropDownSearchableComponent.findOption(option.data, pickSearched, isMatch);
                if (inOptGroup) {
                    return inOptGroup;
                }
            }
            if (isMatch(typeof option === 'string' ? option : pickSearched(option))) {
                return option;
            }
        }
        return undefined;
    }
    ngOnInit() {
        this.searchTerm$
            .pipe(filter((searchTerm) => searchTerm !== undefined), tap((searchTerm) => this.searchTermChanged.emit(searchTerm)), debounceTime$1(400), takeUntil(this.teardown$))
            .subscribe((searchTerm) => {
            const matchedOption = DropDownSearchableComponent.findOption(this.options, ({ label }) => label, (itemValue) => itemValue === searchTerm);
            if (matchedOption) {
                this.valueChanged.emit({
                    value: typeof matchedOption === 'string' ? matchedOption : matchedOption.value,
                    isAuto: true,
                });
            }
        });
    }
    ngOnChanges(changes) {
        if (changes.options) {
            this.options$.next(this.options);
        }
    }
    ngOnDestroy() {
        this.teardown$.next();
    }
    onSearchTermChanged(searchTerm) {
        this.searchTerm$.next(searchTerm);
    }
    onSelectedChanged(selected) {
        if (selected === this.value) {
            return;
        }
        this.onSearchTermChanged('');
        const isValid = selected
            ? DropDownSearchableComponent.findOption(this.options, ({ value, label }) => value ?? label, (itemValue) => itemValue === selected)
            : this.clearable;
        if (isValid) {
            this.valueChanged.emit({ value: selected, isAuto: false });
            return;
        }
        const lastValue = this.value;
        this.value = undefined;
        setTimeout(() => {
            this.value = lastValue;
        });
    }
}
DropDownSearchableComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DropDownSearchableComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
DropDownSearchableComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: DropDownSearchableComponent, selector: "dashboard-builder-drop-down-searchable", inputs: { options: "options", value: "value", placeholder: "placeholder", loading: "loading", disabled: "disabled", clearable: "clearable" }, outputs: { searchTermChanged: "searchTermChanged", valueChanged: "valueChanged" }, usesOnChanges: true, ngImport: i0, template: "<davinci-drop-down\n  [placeholder]=\"placeholder\"\n  [value]=\"value\"\n  [data]=\"fieldOptions$ | async\"\n  [contentRenderer]=\"contentRenderer\"\n  [loading]=\"loading\"\n  [disabled]=\"disabled\"\n  editable\n  (input)=\"onSearchTermChanged($event.detail)\"\n  (change)=\"onSelectedChanged($event.detail)\"\n>\n</davinci-drop-down>\n", styles: [":host{position:relative;display:block}davinci-drop-down{width:100%;margin:0}\n"], dependencies: [{ kind: "pipe", type: i1.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DropDownSearchableComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dashboard-builder-drop-down-searchable', template: "<davinci-drop-down\n  [placeholder]=\"placeholder\"\n  [value]=\"value\"\n  [data]=\"fieldOptions$ | async\"\n  [contentRenderer]=\"contentRenderer\"\n  [loading]=\"loading\"\n  [disabled]=\"disabled\"\n  editable\n  (input)=\"onSearchTermChanged($event.detail)\"\n  (change)=\"onSelectedChanged($event.detail)\"\n>\n</davinci-drop-down>\n", styles: [":host{position:relative;display:block}davinci-drop-down{width:100%;margin:0}\n"] }]
        }], propDecorators: { options: [{
                type: Input
            }], value: [{
                type: Input
            }], placeholder: [{
                type: Input
            }], loading: [{
                type: Input
            }], disabled: [{
                type: Input
            }], clearable: [{
                type: Input
            }], searchTermChanged: [{
                type: Output
            }], valueChanged: [{
                type: Output
            }] } });

let GridTileComponent = class GridTileComponent {
    constructor(el) {
        this.el = el;
        this.x = 0;
        this.y = 0;
        this.rows = 0;
        this.cols = 0;
        this.hideHeader = false;
        this.lock = false;
    }
    ngOnChanges(changes) {
        if (changes.header || changes.link) {
            this.el?.nativeElement.dispatchEvent(new GridTileChangeEvent(this.header, this.link));
        }
    }
    ngAfterViewInit() {
        if (this.header !== undefined) {
            this.el?.nativeElement.dispatchEvent(new GridTileChangeEvent(this.header, this.link));
        }
    }
};
GridTileComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: GridTileComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
GridTileComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: GridTileComponent, selector: "dashboard-grid-tile", inputs: { x: "x", y: "y", rows: "rows", cols: "cols", header: "header", hideHeader: "hideHeader", lock: "lock", link: "link" }, usesOnChanges: true, ngImport: i0, template: '', isInline: true, encapsulation: i0.ViewEncapsulation.ShadowDom });
__decorate([
    Describe({ description: 'Tile header', type: 'string' }),
    __metadata("design:type", String)
], GridTileComponent.prototype, "header", void 0);
__decorate([
    Describe(`Don't show tile header in view mode`),
    __metadata("design:type", Object)
], GridTileComponent.prototype, "hideHeader", void 0);
__decorate([
    Describe('Link to other dashboard'),
    __metadata("design:type", String)
], GridTileComponent.prototype, "link", void 0);
GridTileComponent = __decorate([
    AngularDashboardElement({
        role: 'structure',
        documentation: {
            name: 'Grid tile',
            description: '',
        },
    }),
    __metadata("design:paramtypes", [ElementRef])
], GridTileComponent);
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: GridTileComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'dashboard-grid-tile',
                    template: '',
                    encapsulation: ViewEncapsulation.ShadowDom,
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { x: [{
                type: Input
            }], y: [{
                type: Input
            }], rows: [{
                type: Input
            }], cols: [{
                type: Input
            }], header: [{
                type: Input
            }], hideHeader: [{
                type: Input
            }], lock: [{
                type: Input
            }], link: [{
                type: Input
            }] } });

const flyInAnimation = animation([
    style({
        transform: 'translateX(120%)',
    }),
    animate('0.66s cubic-bezier(0.35, 0, 0.25, 1)'),
]);
const flyOutAnimation = animation([
    animate('0.66s cubic-bezier(0.35, 0, 0.25, 1)', style({ transform: 'translateX(120%)' })),
]);
class ToastComponent {
    constructor(data, snackBarRef) {
        this.data = data;
        this.snackBarRef = snackBarRef;
        this.iconPath = (() => {
            switch (data.type) {
                case 'info':
                    return 'action/info';
                case 'success':
                    return 'action/check_circle';
                case 'warning':
                    return 'alert/warning';
                case 'error':
                    return 'alert/error';
                default:
                    return 'action/info';
            }
        })();
    }
    closeToast() {
        this.snackBarRef.dismiss();
    }
    actionButtonClicked() {
        // TODO when this is needed
    }
}
ToastComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ToastComponent, deps: [{ token: MAT_SNACK_BAR_DATA }, { token: i1$1.MatSnackBarRef }], target: i0.ɵɵFactoryTarget.Component });
ToastComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: ToastComponent, selector: "dashboard-builder-toast", ngImport: i0, template: "<div class=\"container\" [ngClass]=\"data.type\">\n  <div class=\"header\">\n    <davinci-icon [icon]=\"iconPath\" class=\"icon-status\"></davinci-icon>\n    <p class=\"title\">{{ data.title }}</p>\n    <davinci-icon icon=\"navigation/close\" class=\"icon-close\" (click)=\"closeToast()\"></davinci-icon>\n  </div>\n  <div class=\"body\">\n    <p class=\"message\">{{ data.message }}</p>\n  </div>\n  <div *ngIf=\"data.buttonLabel\" class=\"action\">\n    <davinci-button class=\"action-button\" type=\"bare-neutral\" (click)=\"actionButtonClicked()\">{{\n      data.buttonLabel\n    }}</davinci-button>\n  </div>\n</div>\n", styles: [":host{height:100%;display:block;margin-bottom:12px;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}:host .container{color:var(--davinci-color-text-on-information-light,#2C3133);border-left:solid var(--davinci-color-primary,#007CC1) 4px;padding:16px 16px 16px 12px;border-left-color:var(--davinci-color-information,#007cc1);background-color:var(--davinci-color-information-light,#e5f1f8)}:host .header{display:flex;align-items:center}:host .icon-status{height:24px;width:24px;fill:var(--davinci-color-information,#007cc1)}:host .title{margin:0 16px 0 8px;font-weight:700}:host .title .success{color:var(--davinci-color-text-on-success-light,#2C3133)}:host .title .warning{color:var(--davinci-color-text-on-warning-light,#2C3133)}:host .title .error{color:var(--davinci-color-text-on-error-light,#2C3133)}:host .icon-close{height:16px;width:16px;margin-left:auto;cursor:pointer;fill:var(--davinci-color-dark-gray-3,#50585C)}:host .icon-close:hover{fill:var(--davinci-color-dark-gray-2,#2C3133)}:host .body{margin:0 16px 0 32px}:host .message{margin:0 0 2px}:host .action{display:flex;justify-content:flex-end}:host .action-button{height:24px;min-height:24px;margin:0;padding:0;font-size:12px;color:var(--davinci-color-dark-gray-2,#2C3133)}:host .action-button:hover{color:var(--davinci-color-dark-gray-1,#141718)}:host .success{border-left-color:var(--davinci-color-success,#63b017);background-color:var(--davinci-color-success-light,#EFF7E7);color:var(--davinci-color-text-on-success-light,#2C3133)}:host .success .icon-status{fill:var(--davinci-color-success,#63b017)}:host .warning{border-left-color:var(--davinci-color-warning,#F5C413);background-color:var(--davinci-color-warning-light,#FEF9E7);color:var(--davinci-color-text-on-warning-light,#2C3133)}:host .warning .icon-status{fill:var(--davinci-color-warning,#F5C413)}:host .error{border-left-color:var(--davinci-color-error,#EA0823);background-color:var(--davinci-color-error-light,#FCE6E9);color:var(--davinci-color-text-on-error-light,#2C3133)}:host .error .icon-status{fill:var(--davinci-color-error,#EA0823)}\n"], dependencies: [{ kind: "directive", type: i1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], animations: [
        trigger('flyInOut', [
            transition(':enter', [useAnimation(flyInAnimation)]),
            transition(':leave', [useAnimation(flyOutAnimation)]),
        ]),
    ] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ToastComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dashboard-builder-toast', animations: [
                        trigger('flyInOut', [
                            transition(':enter', [useAnimation(flyInAnimation)]),
                            transition(':leave', [useAnimation(flyOutAnimation)]),
                        ]),
                    ], template: "<div class=\"container\" [ngClass]=\"data.type\">\n  <div class=\"header\">\n    <davinci-icon [icon]=\"iconPath\" class=\"icon-status\"></davinci-icon>\n    <p class=\"title\">{{ data.title }}</p>\n    <davinci-icon icon=\"navigation/close\" class=\"icon-close\" (click)=\"closeToast()\"></davinci-icon>\n  </div>\n  <div class=\"body\">\n    <p class=\"message\">{{ data.message }}</p>\n  </div>\n  <div *ngIf=\"data.buttonLabel\" class=\"action\">\n    <davinci-button class=\"action-button\" type=\"bare-neutral\" (click)=\"actionButtonClicked()\">{{\n      data.buttonLabel\n    }}</davinci-button>\n  </div>\n</div>\n", styles: [":host{height:100%;display:block;margin-bottom:12px;box-shadow:0 2px 4px -1px #0003,0 4px 5px #00000024,0 1px 10px #0000001f}:host .container{color:var(--davinci-color-text-on-information-light,#2C3133);border-left:solid var(--davinci-color-primary,#007CC1) 4px;padding:16px 16px 16px 12px;border-left-color:var(--davinci-color-information,#007cc1);background-color:var(--davinci-color-information-light,#e5f1f8)}:host .header{display:flex;align-items:center}:host .icon-status{height:24px;width:24px;fill:var(--davinci-color-information,#007cc1)}:host .title{margin:0 16px 0 8px;font-weight:700}:host .title .success{color:var(--davinci-color-text-on-success-light,#2C3133)}:host .title .warning{color:var(--davinci-color-text-on-warning-light,#2C3133)}:host .title .error{color:var(--davinci-color-text-on-error-light,#2C3133)}:host .icon-close{height:16px;width:16px;margin-left:auto;cursor:pointer;fill:var(--davinci-color-dark-gray-3,#50585C)}:host .icon-close:hover{fill:var(--davinci-color-dark-gray-2,#2C3133)}:host .body{margin:0 16px 0 32px}:host .message{margin:0 0 2px}:host .action{display:flex;justify-content:flex-end}:host .action-button{height:24px;min-height:24px;margin:0;padding:0;font-size:12px;color:var(--davinci-color-dark-gray-2,#2C3133)}:host .action-button:hover{color:var(--davinci-color-dark-gray-1,#141718)}:host .success{border-left-color:var(--davinci-color-success,#63b017);background-color:var(--davinci-color-success-light,#EFF7E7);color:var(--davinci-color-text-on-success-light,#2C3133)}:host .success .icon-status{fill:var(--davinci-color-success,#63b017)}:host .warning{border-left-color:var(--davinci-color-warning,#F5C413);background-color:var(--davinci-color-warning-light,#FEF9E7);color:var(--davinci-color-text-on-warning-light,#2C3133)}:host .warning .icon-status{fill:var(--davinci-color-warning,#F5C413)}:host .error{border-left-color:var(--davinci-color-error,#EA0823);background-color:var(--davinci-color-error-light,#FCE6E9);color:var(--davinci-color-text-on-error-light,#2C3133)}:host .error .icon-status{fill:var(--davinci-color-error,#EA0823)}\n"] }]
        }], ctorParameters: function () { return [{ type: undefined, decorators: [{
                    type: Inject,
                    args: [MAT_SNACK_BAR_DATA]
                }] }, { type: i1$1.MatSnackBarRef }]; } });

/**
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
class NotificationService {
    constructor(snackBar, zone) {
        this.snackBar = snackBar;
        this.zone = zone;
    }
    show(data) {
        this.zone.run(() => {
            this.snackBar.dismiss();
            this.snackBar.openFromComponent(ToastComponent, {
                data,
                duration: 8000,
                panelClass: 'dbb-snackbar',
                verticalPosition: 'bottom',
            });
        });
    }
    showInfo(title, message) {
        this.show({
            title,
            message,
            type: 'info',
        });
    }
    showSuccess(title, message) {
        this.show({
            title,
            message,
            type: 'success',
        });
    }
    showWarning(title, message) {
        this.show({
            title,
            message,
            type: 'warning',
        });
    }
    showError(title, message) {
        this.show({
            title,
            message,
            type: 'error',
        });
    }
    dismiss() {
        this.zone.run(() => {
            this.snackBar.dismiss();
        });
    }
}
NotificationService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: NotificationService, deps: [{ token: i1$1.MatSnackBar }, { token: i0.NgZone }], target: i0.ɵɵFactoryTarget.Injectable });
NotificationService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: NotificationService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: NotificationService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.MatSnackBar }, { type: i0.NgZone }]; } });

const IMAGE_DATA_PATTERN = /^data:image(\/[^;]+)?;base64,/;
function isValidBase64ImageData(imageData) {
    return IMAGE_DATA_PATTERN.test(imageData);
}
function getBase64ImageData(imageData, defaultData) {
    if (!imageData) {
        return defaultData && getBase64ImageData(defaultData);
    }
    return isValidBase64ImageData(imageData) ? imageData : `data:image;base64,${imageData}`;
}
function getBase64ImageDataSize(imageData) {
    if (imageData === '' || !isValidBase64ImageData(imageData)) {
        return 0;
    }
    const [, base64Data] = imageData.split(';base64,');
    try {
        return atob(base64Data).length;
    }
    catch (err) {
        return 0;
    }
}

const IMAGE_MAX_MB = 2;
const IMAGE_MAX_BYTES = IMAGE_MAX_MB * 1024 * 1024;
class ImageSelectComponent {
    constructor(notificationService) {
        this.notificationService = notificationService;
        this.imageChanged = new EventEmitter();
        this.imageData$ = new BehaviorSubject('');
        this.manualImageData$ = new Subject();
        this.stop$ = new Subject();
    }
    ngOnInit() {
        this.imageData$.next(this.base64ImageData);
        this.imageData$.pipe(takeUntil(this.stop$)).subscribe((imageData) => {
            const input = this.inputField?.nativeElement;
            if (input) {
                input.value = imageData;
                input.dispatchEvent(new CustomEvent('change', { detail: imageData }));
                input.setAttribute('value', imageData);
            }
            this.imageChanged.emit(imageData);
        });
        this.manualImageData$
            .pipe(takeUntil(this.stop$), map$1((imageData) => this.checkImageSize(imageData)), distinctUntilChanged())
            .subscribe((imageData) => {
            this.imageData$.next(imageData);
        });
    }
    ngOnDestroy() {
        this.stop$.next();
    }
    onFileChange(files) {
        if (!files || files.length === 0) {
            return;
        }
        const imageFile = files.item(0);
        if (imageFile.size > IMAGE_MAX_BYTES) {
            this.notificationService.showError('File too large', `Maximum image size is ${IMAGE_MAX_MB}MB.`);
            return;
        }
        const reader = new FileReader();
        reader.addEventListener('loadend', () => {
            if (reader.error) {
                this.notificationService.showError('File could not be loaded', 'Try again or choose different file.');
                return;
            }
            const content = String(reader.result);
            if (!isValidBase64ImageData(content)) {
                this.notificationService.showError('File could not be loaded', `File doesn't contain valid image.`);
                return;
            }
            this.imageData$.next(content);
        });
        reader.readAsDataURL(imageFile);
    }
    updateImageManual(content) {
        if (content !== this.imageData$.value) {
            this.manualImageData$.next(content);
        }
    }
    checkImageSize(imageData) {
        const size = getBase64ImageDataSize(imageData);
        if (size <= IMAGE_MAX_BYTES) {
            return imageData;
        }
        this.notificationService.showError('File too large', `Maximum image size is ${IMAGE_MAX_MB}MB.`);
        return imageData === this.imageData$.value ? '' : this.imageData$.value;
    }
    clearImage() {
        this.imageData$.next('');
    }
}
ImageSelectComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ImageSelectComponent, deps: [{ token: NotificationService }], target: i0.ɵɵFactoryTarget.Component });
ImageSelectComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: ImageSelectComponent, selector: "dashboard-builder-image-select", inputs: { linkedElement: "linkedElement", linkedProperty: "linkedProperty", bindingName: "bindingName", base64ImageData: "base64ImageData", allowEmpty: "allowEmpty" }, outputs: { imageChanged: "imageChanged" }, viewQueries: [{ propertyName: "inputField", first: true, predicate: ["inputField"], descendants: true }], ngImport: i0, template: "<ng-template #common>\n  <davinci-file-chooser accept=\"image/*\" (change)=\"onFileChange($event.detail)\" *ngIf=\"!bindingName\"\n    >Select image</davinci-file-chooser\n  >\n  <davinci-button\n    type=\"outline\"\n    icon=\"action/delete\"\n    title=\"Remove image\"\n    class=\"clear-button\"\n    [disabled]=\"(imageData$ | async) === ''\"\n    (click)=\"clearImage()\"\n    *ngIf=\"!isBound && allowEmpty\"\n  ></davinci-button>\n</ng-template>\n\n<div class=\"image-select\">\n  <dashboard-builder-bindable\n    *ngIf=\"linkedElement; else notLinked\"\n    [bound]=\"bindingName !== ''\"\n    [overlayText]=\"bindingName\"\n  >\n    <davinci-text-field\n      #inputField\n      [linkToElement]=\"linkedElement\"\n      [linkToProperty]=\"linkedProperty\"\n      class=\"content-input linked\"\n      (change)=\"updateImageManual($event.detail)\"\n    >\n    </davinci-text-field>\n    <ng-container *ngTemplateOutlet=\"common\"></ng-container>\n  </dashboard-builder-bindable>\n  <ng-template #notLinked>\n    <davinci-text-field\n      #inputField\n      class=\"content-input\"\n      [value]=\"imageData$ | async\"\n      (change)=\"updateImageManual($event.detail)\"\n    >\n    </davinci-text-field>\n    <ng-container *ngTemplateOutlet=\"common\"></ng-container>\n  </ng-template>\n</div>\n", styles: [":host{width:100%}.image-select{display:flex;align-items:center}.image-select>*+*{margin-left:8px}davinci-text-field{margin:0;width:100%}dashboard-builder-bindable{width:100%}dashboard-builder-bindable>*+*{margin-left:8px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { kind: "directive", type: i1.NgTemplateOutlet, selector: "[ngTemplateOutlet]", inputs: ["ngTemplateOutletContext", "ngTemplateOutlet", "ngTemplateOutletInjector"] }, { kind: "directive", type: ElementPropertyLinkingDirective, selector: "[linkToElement][linkToProperty]", inputs: ["linkToElement", "linkToProperty", "linkToIndex", "currentValue"], outputs: ["currentValueChange"], exportAs: ["propertyLink"] }, { kind: "component", type: BindingStateComponent, selector: "dashboard-builder-bindable", inputs: ["bound", "overlayText", "helpTooltipVPos"] }, { kind: "pipe", type: i1.AsyncPipe, name: "async" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ImageSelectComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dashboard-builder-image-select', template: "<ng-template #common>\n  <davinci-file-chooser accept=\"image/*\" (change)=\"onFileChange($event.detail)\" *ngIf=\"!bindingName\"\n    >Select image</davinci-file-chooser\n  >\n  <davinci-button\n    type=\"outline\"\n    icon=\"action/delete\"\n    title=\"Remove image\"\n    class=\"clear-button\"\n    [disabled]=\"(imageData$ | async) === ''\"\n    (click)=\"clearImage()\"\n    *ngIf=\"!isBound && allowEmpty\"\n  ></davinci-button>\n</ng-template>\n\n<div class=\"image-select\">\n  <dashboard-builder-bindable\n    *ngIf=\"linkedElement; else notLinked\"\n    [bound]=\"bindingName !== ''\"\n    [overlayText]=\"bindingName\"\n  >\n    <davinci-text-field\n      #inputField\n      [linkToElement]=\"linkedElement\"\n      [linkToProperty]=\"linkedProperty\"\n      class=\"content-input linked\"\n      (change)=\"updateImageManual($event.detail)\"\n    >\n    </davinci-text-field>\n    <ng-container *ngTemplateOutlet=\"common\"></ng-container>\n  </dashboard-builder-bindable>\n  <ng-template #notLinked>\n    <davinci-text-field\n      #inputField\n      class=\"content-input\"\n      [value]=\"imageData$ | async\"\n      (change)=\"updateImageManual($event.detail)\"\n    >\n    </davinci-text-field>\n    <ng-container *ngTemplateOutlet=\"common\"></ng-container>\n  </ng-template>\n</div>\n", styles: [":host{width:100%}.image-select{display:flex;align-items:center}.image-select>*+*{margin-left:8px}davinci-text-field{margin:0;width:100%}dashboard-builder-bindable{width:100%}dashboard-builder-bindable>*+*{margin-left:8px}\n"] }]
        }], ctorParameters: function () { return [{ type: NotificationService }]; }, propDecorators: { linkedElement: [{
                type: Input
            }], linkedProperty: [{
                type: Input
            }], bindingName: [{
                type: Input
            }], base64ImageData: [{
                type: Input
            }], allowEmpty: [{
                type: Input
            }], imageChanged: [{
                type: Output
            }], inputField: [{
                type: ViewChild,
                args: ['inputField']
            }] } });

class ImageViewComponent {
    constructor(_sanitizer) {
        this._sanitizer = _sanitizer;
        this.base64ImageData = ImageViewComponent.DEFAULT_IMAGE;
        this.hasError = new EventEmitter();
        this.imageSource = this._sanitizer.bypassSecurityTrustUrl(this.toDataUrl(ImageViewComponent.DEFAULT_IMAGE));
    }
    toDataUrl(base64Image) {
        return getBase64ImageData(base64Image, ImageViewComponent.DEFAULT_IMAGE);
    }
    ngAfterViewInit() {
        this.image.nativeElement.addEventListener('error', () => {
            this.hasError.emit();
        });
    }
    ngOnChanges(changes) {
        if (changes.base64ImageData) {
            const dataString = this.toDataUrl(this.base64ImageData);
            this.imageSource = this._sanitizer.bypassSecurityTrustUrl(dataString);
        }
    }
}
ImageViewComponent.DEFAULT_IMAGE = 
// eslint-disable-next-line max-len
'iVBORw0KGgoAAAANSUhEUgAAAIAAAACACAYAAADDPmHLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAD6UlEQVR4nO3bT2tcVRzG8WfSTKKG/jFVrLRCQSvSbWu7sILgn41CgyCib8CNxK2+AXVroNhXoOCijVAXInXlZgwB3QiauhFKUsQ0No5t5sZcF/FAG9PO3HvPueec/r6fVShh5ibPl3szc6cSAAAAAAAAAAAAAAAAAAAAAAAAAAAAstFp+gDl7OwXPg4EtZSdubk3mzzAuIeDeMPDY6CeUlKjAMY8HQgyRQDGEYBxBGAcARhHAMYRgHEEYBwBGEcAxhGAcQRgHAEYRwDG+bgdnKXrt7Z08cpAi9cK/TXY0uNTY3rhiQm9cnRSY40/JZEPkwFc+nVDs9/e0O83yzv+/dwPN3XmcFefvrRPR/fviXR07TJ3Cfio19dbX/35v/Gd764WOv3ZqhavbbZ8ZHGYCmBhpdDH3/eHft/fRal3vrmhW//4P4becqGZ+TWtD3YPsG1mAiglvXt5XVsj/t5/Xt3UJ4vDY6mit1zo7PyaLv820NlEIjATwC+rm/rpj2qn9QtLG96e343fL7ZHX1gpkojATABX1qqfz5eu+/k7YOf4TgoRmAkglruN78SOwEwATx2o/rLu2MPNXiUPG9+JGYGZAJ6eHtfxg9UGff3YZO3nG3V8J1YEZgLoSDr34t6R3+V7Znpc752YqvVcVcd3YkRgJgBJOnmoq/dPDR/1oW5H51/epwdqvBlYd3yn7QhMBSBJH5ye0uev7tejD+5+Knj+yIR6b0/rxGPVr/9Nx3fajMDkvYDXnpzUmSOP6MLShrebQb7Gd1wEX84c0N6JcHenfPzv4PhvZ0Xme/zbPXuoe68Iys7cXKOzuLlLgG8hx5fCXw4IoIHQ4zshIyCAmtoa3wkVAQHU0Pb4TogI7osA1gelZubX1Fsugj9XrPEd3xFkH8D6oLzjHnvICGKP7/iMIOsA3PgLK9uj94syWASpjO/8F0Hjl/HZBrBzfCdEBKmN7+z82evIMoC7je/4jCDV8X3JLoBh4zs+Irjfx5cyC2DU8Z0mEVgYX8oogKrjO3UisDK+lEkAdcd3qkRgaXwpgwCaju+MEoG18aXEA/A1vnOvCCyOLyUcgO/xnd0isDq+lGgAocZ3bo/A8vhSgh8JCz2+4yJwX1uVVABtje9YHt5J5hLQ9vjYlkQAjB9P9AAYP66oATB+fNECYPw0RAmA8dPRegCMn5ZWA2D89LQWAOOnqZUAGD9dwQNg/LQFDYDx0xcsAMbPQ5AAGD8f3gNg/Lx4DYDx8+MtAMbPk5cAGD9fjQNg/Lw1/kzgh73+jxN7dPC5w10fx4OKvr4a+wgAAAAAAAAAAAAAAAAAAAAAAAAAAADQmn8Bz5gnU8y5SYsAAAAASUVORK5CYII=';
ImageViewComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ImageViewComponent, deps: [{ token: i1$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Component });
ImageViewComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: ImageViewComponent, selector: "dashboard-builder-image-view", inputs: { base64ImageData: "base64ImageData" }, outputs: { hasError: "hasError" }, viewQueries: [{ propertyName: "image", first: true, predicate: ["image"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<img #image class=\"image\" [src]=\"imageSource\" alt=\"Selected image\" />\n", styles: [":host{display:flex;align-items:center;justify-content:center;width:100%;height:100%}.image{max-width:100%;max-height:100%}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ImageViewComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dashboard-builder-image-view', template: "<img #image class=\"image\" [src]=\"imageSource\" alt=\"Selected image\" />\n", styles: [":host{display:flex;align-items:center;justify-content:center;width:100%;height:100%}.image{max-width:100%;max-height:100%}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.DomSanitizer }]; }, propDecorators: { base64ImageData: [{
                type: Input
            }], hasError: [{
                type: Output
            }], image: [{
                type: ViewChild,
                args: ['image']
            }] } });

class SpecializedBindingPropertiesComponent {
    constructor() {
        this.propertyChange = new EventEmitter();
        this.hasError = new EventEmitter();
        this.propertyChanged$ = new Subject();
        this.propertyChanged$
            .pipe(debounceTime(500))
            .pipe(map(() => this.formHasErrors()), filter((formHasErrors) => formHasErrors !== undefined))
            .subscribe((formHasErrors) => {
            this.setFormReady(!formHasErrors);
        });
    }
    onPropertyChange() {
        this.propertyChanged$.next();
    }
    setFormReady(ready) {
        setTimeout(() => this.hasError.emit(!ready));
    }
    // eslint-disable-next-line jsdoc/require-description
    /**
     * @deprecated call setFormReady explicitly instead
     */
    formHasErrors() {
        return undefined;
    }
}
SpecializedBindingPropertiesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: SpecializedBindingPropertiesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SpecializedBindingPropertiesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: SpecializedBindingPropertiesComponent, selector: "ng-component", inputs: { propertyType: "propertyType", binding: "binding" }, outputs: { propertyChange: "propertyChange", hasError: "hasError" }, host: { listeners: { "propertyChange": "onPropertyChange()", "propertyStructureChange": "onPropertyChange()" } }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: SpecializedBindingPropertiesComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], ctorParameters: function () { return []; }, propDecorators: { propertyType: [{
                type: Input
            }], binding: [{
                type: Input
            }], propertyChange: [{
                type: Output
            }], hasError: [{
                type: Output
            }], onPropertyChange: [{
                type: HostListener,
                args: [PropertyChangeEvent.TYPE]
            }, {
                type: HostListener,
                args: [PropertyStructureChangeEvent.TYPE]
            }] } });

class SpecializedElementPropertiesComponent {
    constructor() {
        this.generalPalette = DEFAULT_PALLETE;
        this.propertyChange = new EventEmitter();
        this.propertyStructureChange = new EventEmitter();
        this.addBindingDialog = new EventEmitter();
        this.removeBindingFromProperty = new EventEmitter();
        this.bindings$ = new BehaviorSubject([]);
        this.teardown$ = new Subject();
    }
    set bindings(bindings) {
        this.bindings$.next(bindings);
    }
    get bindings() {
        return this.bindings$.value;
    }
    static updateBoundState(bindings, directives) {
        for (const d of directives) {
            const b = bindings.find((pb) => pb.property.name === d.linkToProperty && pb.property.index === d.linkToIndex);
            if (b) {
                d.bound = true;
                d.overlayText = dashboardElements.getDescription(b.instance.tag).documentation.name;
            }
        }
    }
    ngAfterViewInit() {
        combineLatest([this.bindings$, this.bindingDirectives.changes.pipe(startWith(this.bindingDirectives))])
            .pipe(takeUntil$1(this.teardown$))
            .subscribe(([bindings, directives]) => setTimeout(() => SpecializedElementPropertiesComponent.updateBoundState(bindings, directives)));
    }
    ngOnDestroy() {
        this.teardown$.next();
    }
}
SpecializedElementPropertiesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: SpecializedElementPropertiesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
SpecializedElementPropertiesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: SpecializedElementPropertiesComponent, selector: "ng-component", inputs: { element: "element", bindings: "bindings", generalPalette: "generalPalette" }, outputs: { propertyChange: "propertyChange", propertyStructureChange: "propertyStructureChange", addBindingDialog: "addBindingDialog", removeBindingFromProperty: "removeBindingFromProperty" }, viewQueries: [{ propertyName: "bindingDirectives", predicate: BindingStateComponent, descendants: true }], ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: SpecializedElementPropertiesComponent, decorators: [{
            type: Component,
            args: [{
                    template: '',
                }]
        }], propDecorators: { element: [{
                type: Input
            }], bindings: [{
                type: Input
            }], generalPalette: [{
                type: Input
            }], propertyChange: [{
                type: Output
            }], propertyStructureChange: [{
                type: Output
            }], addBindingDialog: [{
                type: Output
            }], removeBindingFromProperty: [{
                type: Output
            }], bindingDirectives: [{
                type: ViewChildren,
                args: [BindingStateComponent]
            }] } });

class UserInputComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.showBalloon = false;
    }
    get hintText() {
        return this.error || this.warning || this.info;
    }
    ngOnChanges(changes) {
        if (changes.error || changes.warning) {
            const input = this.elementRef.nativeElement?.querySelector('davinci-text-field, davinci-text-area');
            if (input) {
                input.error = Boolean(this.error);
                input.warning = !this.error && Boolean(this.warning);
            }
        }
    }
}
UserInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: UserInputComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
UserInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.0.0", type: UserInputComponent, selector: "dashboard-builder-user-input", inputs: { error: "error", warning: "warning", info: "info" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"container\" [class.has-hint]=\"hintText\">\n  <ng-content></ng-content>\n  <div *ngIf=\"hintText\">\n    <davinci-status-text\n      [error]=\"!!error\"\n      [warning]=\"!error && !!warning\"\n      (mouseenter)=\"showBalloon = true\"\n      (mouseleave)=\"showBalloon = false\"\n      (click)=\"showBalloon = true\"\n    >\n      <div class=\"text-container\">\n        <div class=\"text\" [class.warning]=\"!error && !!warning\" [class.info]=\"!error && !warning\">{{ hintText }}</div>\n      </div>\n    </davinci-status-text>\n    <davinci-balloon position=\"bottom\" alignment=\"bottom\" for=\":before\" [show]=\"showBalloon\">\n      <div class=\"balloon-content\">{{ hintText }}</div>\n    </davinci-balloon>\n  </div>\n</div>\n", styles: [".container{position:relative;width:100%}.container.has-hint davinci-status-text{left:0;bottom:-1.3rem;max-width:100%;height:1rem}.container.has-hint .text-container{position:absolute;width:100%}.container.has-hint .text{font-size:.9rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.container.has-hint .text.warning{color:var(--davinci-color-accent,#F39200)}.container.has-hint .text.info{color:var(--davinci-color-secondary,#737F85)}.container.has-hint .balloon-content{max-width:350px}\n"], dependencies: [{ kind: "directive", type: i1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: UserInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'dashboard-builder-user-input', template: "<div class=\"container\" [class.has-hint]=\"hintText\">\n  <ng-content></ng-content>\n  <div *ngIf=\"hintText\">\n    <davinci-status-text\n      [error]=\"!!error\"\n      [warning]=\"!error && !!warning\"\n      (mouseenter)=\"showBalloon = true\"\n      (mouseleave)=\"showBalloon = false\"\n      (click)=\"showBalloon = true\"\n    >\n      <div class=\"text-container\">\n        <div class=\"text\" [class.warning]=\"!error && !!warning\" [class.info]=\"!error && !warning\">{{ hintText }}</div>\n      </div>\n    </davinci-status-text>\n    <davinci-balloon position=\"bottom\" alignment=\"bottom\" for=\":before\" [show]=\"showBalloon\">\n      <div class=\"balloon-content\">{{ hintText }}</div>\n    </davinci-balloon>\n  </div>\n</div>\n", styles: [".container{position:relative;width:100%}.container.has-hint davinci-status-text{left:0;bottom:-1.3rem;max-width:100%;height:1rem}.container.has-hint .text-container{position:absolute;width:100%}.container.has-hint .text{font-size:.9rem;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.container.has-hint .text.warning{color:var(--davinci-color-accent,#F39200)}.container.has-hint .text.info{color:var(--davinci-color-secondary,#737F85)}.container.has-hint .balloon-content{max-width:350px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { error: [{
                type: Input
            }], warning: [{
                type: Input
            }], info: [{
                type: Input
            }] } });

class DblTapDirective {
    constructor(elRef) {
        this.destroy$ = new Subject();
        this.dbltap = new EventEmitter();
        const { nativeElement: el } = elRef;
        fromEvent(el, 'touchstart')
            .pipe(takeUntil$1(this.destroy$))
            .subscribe(() => {
            if (DblTapDirective.TOUCHED_EL === el) {
                this.dbltap.emit();
                DblTapDirective.TOUCHED_EL = undefined;
                DblTapDirective.CANCEL$.next(undefined);
            }
            else {
                DblTapDirective.TOUCHED_EL = el;
                DblTapDirective.CANCEL$.next(el);
            }
        });
        if (DblTapDirective.INITIALIZED) {
            return;
        }
        fromEvent(window, 'scroll', { capture: true })
            .pipe(debounceTime(10))
            .subscribe(() => {
            DblTapDirective.TOUCHED_EL = undefined;
        });
        DblTapDirective.CANCEL$.pipe(debounceTime(500)).subscribe((el) => {
            if (el === DblTapDirective.TOUCHED_EL) {
                DblTapDirective.TOUCHED_EL = undefined;
            }
        });
        DblTapDirective.INITIALIZED = true;
    }
    ngOnDestroy() {
        this.destroy$.next();
    }
}
DblTapDirective.CANCEL$ = new Subject();
DblTapDirective.INITIALIZED = false;
DblTapDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DblTapDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
DblTapDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.0", type: DblTapDirective, selector: "[dbltap]", outputs: { dbltap: "dbltap" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DblTapDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[dbltap]',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { dbltap: [{
                type: Output
            }] } });

var ScrollDirection;
(function (ScrollDirection) {
    ScrollDirection[ScrollDirection["Up"] = 1] = "Up";
    ScrollDirection[ScrollDirection["Down"] = 2] = "Down";
    ScrollDirection[ScrollDirection["Left"] = 4] = "Left";
    ScrollDirection[ScrollDirection["Right"] = 8] = "Right";
})(ScrollDirection || (ScrollDirection = {}));
class EdgeScrollDirective {
    constructor(element) {
        this.element = element;
        this.edgeScrollEnabled = true;
        this.edgeScrollStep = 20;
        this.edgeScrollArea = 50;
        this.edgeScrolled = new EventEmitter();
        this.stop$ = new Subject();
    }
    ngOnChanges(changes) {
        if (changes.edgeScrollEnabled) {
            this.stop$.next();
            if (this.edgeScrollEnabled) {
                this.initScrollHandler();
            }
        }
    }
    ngOnDestroy() {
        this.stop$.next();
    }
    initScrollHandler() {
        const scroll$ = new Subject();
        fromEvent(window, 'pointermove')
            .pipe(takeUntil(this.stop$), throttleTime(200, asyncScheduler, { leading: false, trailing: true }))
            .subscribe((ev) => {
            const { top, left, width, height } = this.element.nativeElement.getBoundingClientRect();
            let scrollDir = 0;
            if (ev.clientY <= top + this.edgeScrollArea) {
                scrollDir = scrollDir | ScrollDirection.Up;
            }
            else if (ev.clientY >= top + height - this.edgeScrollArea) {
                scrollDir = scrollDir | ScrollDirection.Down;
            }
            if (ev.clientX <= left + this.edgeScrollArea) {
                scrollDir = scrollDir | ScrollDirection.Left;
            }
            else if (ev.clientX >= left + width - this.edgeScrollArea) {
                scrollDir = scrollDir | ScrollDirection.Right;
            }
            scroll$.next(scrollDir);
        });
        scroll$
            .pipe(distinctUntilChanged(), switchMap((dir) => dir
            ? interval(100).pipe(takeUntil(this.stop$), map$1(() => dir))
            : EMPTY))
            .subscribe((dir) => {
            const el = this.element.nativeElement;
            if ((dir & ScrollDirection.Up) === ScrollDirection.Up) {
                el.scrollTop -= this.edgeScrollStep;
            }
            else if ((dir & ScrollDirection.Down) === ScrollDirection.Down) {
                el.scrollTop += this.edgeScrollStep;
            }
            if ((dir & ScrollDirection.Left) === ScrollDirection.Left) {
                el.scrollLeft -= this.edgeScrollStep;
            }
            else if ((dir & ScrollDirection.Right) === ScrollDirection.Right) {
                el.scrollLeft += this.edgeScrollStep;
            }
            this.edgeScrolled.next();
        });
    }
}
EdgeScrollDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: EdgeScrollDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
EdgeScrollDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.0", type: EdgeScrollDirective, selector: "[edgeScroll]", inputs: { edgeScrollEnabled: "edgeScrollEnabled", edgeScrollStep: "edgeScrollStep", edgeScrollArea: "edgeScrollArea" }, outputs: { edgeScrolled: "edgeScrolled" }, exportAs: ["propertyLink"], usesOnChanges: true, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: EdgeScrollDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: '[edgeScroll]',
                    exportAs: 'propertyLink',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { edgeScrollEnabled: [{
                type: Input
            }], edgeScrollStep: [{
                type: Input
            }], edgeScrollArea: [{
                type: Input
            }], edgeScrolled: [{
                type: Output
            }] } });

// Adds functionality to Davinci numeric fields:
// 1. Davinci numeric field doesn't emit event when value is changed due to min/max/format/ticks restrictions,
//    which can lead to incosistent state, so this directive emits the change manually in such case
// 2. Emits actual value to provided subject
class NumericFieldValueDirective {
    constructor(el) {
        this.el = el;
        this.numericValueChange = new EventEmitter();
    }
    ngOnInit() {
        this.observer = new MutationObserver(() => this.checkValueChange());
        this.observer.observe(this.el.nativeElement, {
            attributeFilter: ['format-pattern', 'min', 'max', 'ticks', 'align-to-ticks'],
        });
        this.el.nativeElement.addEventListener('input', (ev) => {
            this.updateValue(parseFloat(ev.detail));
        });
        this.el.nativeElement.addEventListener(PropertyChangeEvent.TYPE, (ev) => {
            // wait for ElementPropertyLinkingDirective to propagate values for all fields
            setTimeout(() => {
                this.updateValue(ev.detail.value);
            });
        });
    }
    updateValue(value) {
        if (isNaN(value)) {
            return;
        }
        const { min = Number.MIN_SAFE_INTEGER, max = Number.MAX_SAFE_INTEGER } = this.el.nativeElement;
        this.numericValueChange.next(Math.min(max, Math.max(min, value)));
    }
    checkValueChange() {
        const oldValue = this.getInputValue();
        requestAnimationFrame(() => {
            const newValue = this.getInputValue();
            if (!isNaN(newValue) && oldValue !== newValue) {
                this.el.nativeElement.dispatchEvent(new CustomEvent('change', {
                    detail: newValue,
                }));
                this.el.nativeElement.value = newValue;
            }
        });
    }
    getInputValue() {
        return parseFloat(this.el.nativeElement.shadowRoot?.querySelector('input[type="text"]')?.title);
    }
}
NumericFieldValueDirective.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: NumericFieldValueDirective, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive });
NumericFieldValueDirective.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "14.0.0", type: NumericFieldValueDirective, selector: "davinci-numeric-field", outputs: { numericValueChange: "numericValueChange" }, ngImport: i0 });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: NumericFieldValueDirective, decorators: [{
            type: Directive,
            args: [{
                    // eslint-disable-next-line @angular-eslint/directive-selector
                    selector: 'davinci-numeric-field',
                }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { numericValueChange: [{
                type: Output
            }] } });

class DashboardBuilderCoreModule {
}
DashboardBuilderCoreModule.REGISTER = [GridTileComponent];
DashboardBuilderCoreModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderCoreModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
DashboardBuilderCoreModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderCoreModule, declarations: [GridTileComponent,
        SpecializedElementPropertiesComponent,
        SpecializedBindingPropertiesComponent,
        ElementPropertyLinkingDirective,
        BindingExecutionResultComponent,
        DropDownSearchableComponent,
        ImageSelectComponent,
        ImageViewComponent,
        NumericFieldValueDirective,
        BindingStateComponent,
        HelpStateComponent,
        ToastComponent,
        UserInputComponent,
        BadgeComponent,
        DblTapDirective,
        EdgeScrollDirective], imports: [CommonModule, MatSnackBarModule], exports: [GridTileComponent,
        SpecializedElementPropertiesComponent,
        SpecializedBindingPropertiesComponent,
        ElementPropertyLinkingDirective,
        BindingExecutionResultComponent,
        DropDownSearchableComponent,
        ImageSelectComponent,
        ImageViewComponent,
        NumericFieldValueDirective,
        BindingStateComponent,
        HelpStateComponent,
        UserInputComponent,
        BadgeComponent,
        DblTapDirective,
        EdgeScrollDirective] });
DashboardBuilderCoreModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderCoreModule, imports: [CommonModule, MatSnackBarModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: DashboardBuilderCoreModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [CommonModule, MatSnackBarModule],
                    declarations: [
                        GridTileComponent,
                        SpecializedElementPropertiesComponent,
                        SpecializedBindingPropertiesComponent,
                        ElementPropertyLinkingDirective,
                        BindingExecutionResultComponent,
                        DropDownSearchableComponent,
                        ImageSelectComponent,
                        ImageViewComponent,
                        NumericFieldValueDirective,
                        BindingStateComponent,
                        HelpStateComponent,
                        ToastComponent,
                        UserInputComponent,
                        BadgeComponent,
                        DblTapDirective,
                        EdgeScrollDirective,
                    ],
                    exports: [
                        GridTileComponent,
                        SpecializedElementPropertiesComponent,
                        SpecializedBindingPropertiesComponent,
                        ElementPropertyLinkingDirective,
                        BindingExecutionResultComponent,
                        DropDownSearchableComponent,
                        ImageSelectComponent,
                        ImageViewComponent,
                        NumericFieldValueDirective,
                        BindingStateComponent,
                        HelpStateComponent,
                        UserInputComponent,
                        BadgeComponent,
                        DblTapDirective,
                        EdgeScrollDirective,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

function getElementPropertyType(elementTag, property) {
    const propertyType = dashboardElements.getProperty(elementTag, property.name)?.type ?? 'unknown';
    if (property.index !== undefined) {
        if (!propertyType.endsWith('[]') && !['unknown', 'any'].includes(propertyType)) {
            // eslint-disable-next-line no-console
            console.warn(`Attempting to index-access property ${elementTag}:${property.name}[${property.index}],
        but type of property is not an array (type: ${propertyType}})`);
            return propertyType;
        }
        return propertyType.substring(0, propertyType.length - 2);
    }
    return propertyType;
}
function guessType(value) {
    if (typeof value !== 'object' && typeof value !== 'undefined') {
        return typeof value;
    }
    let subValue = value;
    let suffix = '';
    while (Array.isArray(subValue)) {
        suffix += '[]';
        subValue = subValue.length ? subValue[0] : undefined;
    }
    const elemType = typeof subValue;
    if (elemType === 'undefined') {
        return 'unknown' + suffix;
    }
    return elemType + suffix;
}
function areTypesCompatible(valueType, targetType, value) {
    const bypassTypes = ['unknown', 'any'];
    return (bypassTypes.includes(valueType) ||
        bypassTypes.includes(targetType) ||
        targetType.split('|').some((part) => {
            try {
                return JSON.parse(part.trim()) === value;
            }
            catch (err) {
                return part.trim() === valueType;
            }
        }));
}
function maybeConvertValue(value, targetType) {
    const valueType = guessType(value);
    if (targetType === 'string' && ['number', 'boolean'].includes(valueType)) {
        return String(value);
    }
    if (targetType === 'string[]' && ['number[]', 'boolean[]'].includes(valueType)) {
        return value.map(String);
    }
    if (targetType === 'number' && ['boolean', 'string'].includes(valueType)) {
        const convertedNumber = Number(value);
        return isNaN(convertedNumber) ? value : convertedNumber;
    }
    if (targetType === 'number[]' && ['boolean[]', 'string[]'].includes(valueType)) {
        const convertedNumbers = value.map(Number);
        return convertedNumbers.some(isNaN) ? value : convertedNumbers;
    }
    return value;
}

class ElementDefinitionService {
    constructor(injector, resolver) {
        this.injector = injector;
        this.resolver = resolver;
        this.cache$ = new BehaviorSubject([]);
        this.cache$.next(dashboardElements.getDescriptions());
        dashboardElements.registerElementDefinitionCallback((newElement) => this.cache$.next(this.cache$.value.concat(newElement)));
        const providers = angularDefinitionProviders();
        angularDashboardElementComponents().map((component) => {
            const childToParentDefinitions = [];
            let c = component;
            while (providers.has(c)) {
                childToParentDefinitions.push(providers.get(c));
                c = Object.getPrototypeOf(c);
            }
            const def = childToParentDefinitions
                .reverse()
                .reduce((parent, child) => ElementDefinitionService.mergeDefinitions(parent, child), {});
            this.defineAngularDashboardElement(component, def);
        });
        angularPropertiesComponents().forEach((e) => this.defineAngularPropertiesElement(e));
    }
    static mergeDefinitions(parent, child) {
        const parentProperties = parent?.properties?.map((pProperty) => {
            const cProperty = child?.properties?.find((cProperty) => cProperty.name === pProperty.name);
            // all or nothing: if child uses @Describe it will override everything that was set by parent's @Describe
            return cProperty ? cProperty : pProperty;
        }) ?? [];
        const childOnlyProperties = child?.properties?.filter((cProperty) => !parent?.properties?.find((pProperty) => pProperty.name === cProperty.name)) ?? [];
        return { ...child, properties: parentProperties.concat(childOnlyProperties) };
    }
    static generateComponentsJson(elemDef, injector, cf) {
        const c = cf.create(injector);
        const properties = new Array();
        for (const property of cf.inputs) {
            const name = property.propName;
            const existingProperty = elemDef.properties.find((p) => p.name === name);
            const defaultValue = c.instance[name];
            const defaultValueType = existingProperty?.type ? existingProperty.type : guessType(defaultValue);
            const mergedProperty = merge$1({
                name,
                attributeName: kebabCase(name),
                ...(defaultValue !== undefined
                    ? {
                        defaultValue,
                        defaultValueType,
                    }
                    : {}),
                type: defaultValueType,
                description: '',
            }, existingProperty);
            properties.push(mergedProperty);
        }
        const completeElemDef = { ...elemDef };
        completeElemDef.tag = completeElemDef.tag ?? cf.selector;
        completeElemDef.properties = properties;
        // TODO check if it's really complete
        return completeElemDef;
    }
    get allAvailableElements() {
        return this.cache$;
    }
    get availableUiElements() {
        return this.allAvailableElements.pipe(map((defs) => defs.filter((def) => def.role === 'ui')));
    }
    get availableBindingElements() {
        return this.allAvailableElements.pipe(map((defs) => defs.filter((def) => def.role === 'behavior')));
    }
    /**
     * Will process the given input and try to register it as a dashboard element. This process will fail if:
     * 1. The input is not a component or if it's an abstract class
     * 2. The input is a component but does not define a selector
     *
     * @param component - the component to register
     * @param def - the (partial) definition to apply for metadata (most commonly description)
     */
    defineAngularDashboardElement(component, def) {
        const factory = this.resolver.resolveComponentFactory(component);
        if (factory.selector === 'ng-component') {
            throw new Error("Either no selector is defined, or the component is using the default 'ng-component' selector");
        }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (factory.componentDef?.encapsulation !== ViewEncapsulation.ShadowDom ?? false) {
            // eslint-disable-next-line no-console
            console.warn(`Element '${factory.selector}' does not have ViewEncapsulation.ShadowDom set. This can cause unexpected issues and is not recommended.`);
        }
        const componentsJson = ElementDefinitionService.generateComponentsJson(def, this.injector, factory);
        const customElementConstructor = createCustomElement(component, { injector: this.injector });
        dashboardElements.define(componentsJson.tag, customElementConstructor, undefined, componentsJson);
    }
    defineAngularPropertiesElement(component) {
        const customElement = createCustomElement(component, { injector: this.injector });
        const factory = this.resolver.resolveComponentFactory(component);
        customElements.define(factory.selector, customElement);
    }
}
ElementDefinitionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ElementDefinitionService, deps: [{ token: i0.Injector }, { token: i0.ComponentFactoryResolver }], target: i0.ɵɵFactoryTarget.Injectable });
ElementDefinitionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ElementDefinitionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ElementDefinitionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i0.Injector }, { type: i0.ComponentFactoryResolver }]; } });

/* istanbul ignore file */
const MESSAGE_NAME_RUN = 'function-run';
const MESSAGE_NAME_CHECK = 'function-check';
class FunctionExecutionService {
    constructor() {
        this.listenersMap = new Map();
        this.iframe = document.getElementById(FunctionExecutionService.IFRAME_ID);
        if (this.iframe instanceof HTMLIFrameElement) {
            return;
        }
        const nonce = String(Math.random()).slice(2);
        const iframeScript = () => {
            window.addEventListener('message', function (e) {
                let resultData;
                try {
                    const fn = Function(`return ${e.data.code}`)();
                    if (e.data.name === 'function-check') {
                        resultData = {
                            type: 'success',
                            result: typeof fn === 'function',
                        };
                    }
                    else {
                        const result = fn(...e.data.params);
                        resultData = {
                            type: 'success',
                            result,
                        };
                    }
                }
                catch (err) {
                    resultData = {
                        type: 'error',
                        err,
                    };
                }
                try {
                    window.parent.postMessage({
                        name: e.data.name,
                        id: e.data.id,
                        data: resultData,
                    }, '*');
                }
                catch (err) {
                    window.parent.postMessage({
                        name: e.data.name,
                        id: e.data.id,
                        data: {
                            type: 'error',
                            err,
                        },
                    }, '*');
                }
            });
        };
        this.iframe = document.createElement('iframe');
        this.iframe.setAttribute('id', FunctionExecutionService.IFRAME_ID);
        this.iframe.setAttribute('src', 'about:blank');
        this.iframe.setAttribute('sandbox', 'allow-scripts');
        this.iframe.srcdoc = `
      <head>
        <meta http-equiv="Content-Security-Policy" content="default-src 'none'; script-src 'nonce-${nonce}' 'unsafe-eval'; navigate-to 'none'">
      </head>
      <script nonce="${nonce}">
        var MESSAGE_NAME_RUN = '${MESSAGE_NAME_RUN}';
        var MESSAGE_NAME_CHECK = '${MESSAGE_NAME_CHECK}';
        (${iframeScript.toString()})();
      </script>`;
        this.iframe.style.display = 'none';
        document.body.appendChild(this.iframe);
        window.addEventListener('message', (ev) => {
            if (ev.data?.name !== MESSAGE_NAME_CHECK && ev.data?.name !== MESSAGE_NAME_RUN) {
                return;
            }
            const { id, data } = ev.data;
            const cb = this.listenersMap.get(id);
            if (cb) {
                cb.next(data);
            }
        });
    }
    isValid(code) {
        return defer(() => {
            const id = FunctionExecutionService.REQUEST_ID++;
            const subject = new Subject();
            this.listenersMap.set(id, subject);
            this.iframe.contentWindow.postMessage({
                name: MESSAGE_NAME_CHECK,
                id,
                code,
            }, '*');
            return subject.pipe(tap$1(() => {
                this.listenersMap.delete(id);
            }), map((data) => (data.type === 'success' ? Boolean(data.result) : false)));
        });
    }
    run(code, ...params) {
        const id = FunctionExecutionService.REQUEST_ID++;
        const subject = new Subject();
        this.listenersMap.set(id, subject);
        return defer(() => {
            this.iframe.contentWindow.postMessage({
                name: MESSAGE_NAME_RUN,
                id,
                code,
                params,
            }, '*');
            return subject;
        }).pipe(map((data) => {
            {
                if (data.type === 'success') {
                    return data.result;
                }
                throw data.err;
            }
        }), finalize(() => {
            this.listenersMap.delete(id);
        }));
    }
}
FunctionExecutionService.REQUEST_ID = 1;
FunctionExecutionService.IFRAME_ID = 'dashboard-builder-function-execution-service-iframe';
FunctionExecutionService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: FunctionExecutionService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
FunctionExecutionService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: FunctionExecutionService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: FunctionExecutionService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

const globalCSS = {
    'dbb-neutral-750': '#383E41',
    'dbb-neutral-20': '#F6F7F7',
    'dbb-neutral-100': '#E0E3E4',
};
const THEMES = {
    'light-theme': {
        ...globalCSS,
        'dbb-dashboard-header-background': 'var(--dbb-neutral-20)',
        'dbb-dashboard-grid-background': 'var(--dbb-neutral-20)',
        'dbb-selected-nodes-actions-background': 'var(--dbb-neutral-100)',
        'dbb-selected-nodes-selected-text': 'var(--davinci-color-dark-gray-2)',
        'dbb-selected-nodes-clear': 'var(--davinci-color-dark-gray-3)',
        'dbb-selected-nodes-clear-hover': 'var(--davinci-color-dark-gray-4)',
        'dbb-selected-nodes-select-all': 'var(--davinci-color-dark-gray-3)',
        'dbb-selected-nodes-select-all-hover': 'var(--davinci-color-dark-gray-4)',
    },
    'dark-theme': {
        ...globalCSS,
        'dbb-dashboard-header-background': '#232323',
        'dbb-dashboard-grid-background': '#232323',
        'dbb-selected-nodes-actions-background': 'var(--dbb-neutral-750)',
        'dbb-selected-nodes-selected-text': 'var(--davinci-color-light-gray-1)',
        'dbb-selected-nodes-clear': 'var(--davinci-color-mid-gray-2)',
        'dbb-selected-nodes-clear-hover': 'var(--davinci-color-mid-gray-3)',
        'dbb-selected-nodes-select-all': 'var(--davinci-color-mid-gray-1)',
        'dbb-selected-nodes-select-all-hover': 'var(--davinci-color-mid-gray-2)',
    },
};

/**
 * @copyright
 * Copyright(c) 2021 SICK AG
 */
class ThemingService {
    constructor(document, rendererFactory, baseHref, location) {
        this.document = document;
        this.baseHref = baseHref;
        this._currentTheme$ = new BehaviorSubject('light-theme');
        this.assetThemesUrl = `${this.baseHref || ''}assets/themes`;
        this.supportedThemes = new Map([
            ['light-theme', ['light_theme.css', 'light_ddg_theme.css'].map((css) => `${this.assetThemesUrl}/${css}`)],
            ['dark-theme', ['dark_theme.css', 'dark_ddg_theme.css'].map((css) => `${this.assetThemesUrl}/${css}`)],
        ]);
        this.forcedTheme = false;
        this.renderer = rendererFactory.createRenderer(null, null);
        this._currentTheme$.next(this.getUserPreferredTheme());
        this._currentTheme$
            .pipe(tap$1((theme) => {
            if (!this.forcedTheme) {
                this.setUserPreferredTheme(theme);
            }
        }), switchMap((theme) => this.setTheme(theme)))
            .subscribe({
            // eslint-disable-next-line no-console
            error: (err) => console.error(err),
        });
        // TODO: hotfix to make release notes readable
        location.onUrlChange((url) => {
            if (url.endsWith('/release-notes')) {
                this.forcedTheme = true;
                this._currentTheme$.next('light-theme');
            }
            else if (this.forcedTheme) {
                this.forcedTheme = false;
                this._currentTheme$.next(this.getUserPreferredTheme());
            }
        });
    }
    get currentTheme() {
        return this._currentTheme$.value;
    }
    get currentTheme$() {
        return this._currentTheme$;
    }
    setThemeProfile(theme) {
        switch (theme) {
            case 'dark-theme':
                this._currentTheme$.next('dark-theme');
                break;
            case 'light-theme':
            default:
                this._currentTheme$.next('light-theme');
                break;
        }
    }
    setUserPreferredTheme(theme) {
        localStorage.setItem(ThemingService.KEY_THEME, theme);
    }
    getUserPreferredTheme() {
        const storedTheme = localStorage.getItem(ThemingService.KEY_THEME);
        if (storedTheme && this.supportedThemes.has(storedTheme)) {
            return storedTheme;
        }
        const userPrefersDarkTheme = this.document.defaultView?.matchMedia?.('(prefers-color-scheme: dark)')?.matches;
        return userPrefersDarkTheme ? 'dark-theme' : 'light-theme';
    }
    setTheme(theme) {
        return defer(() => {
            // internal theme
            const internalTheme = THEMES[theme];
            Object.keys(internalTheme).forEach((key) => {
                this.document.documentElement.style.setProperty(`--${key}`, internalTheme[key]);
            });
            // external theme css files
            document.head
                .querySelectorAll('#theme-css')
                .forEach((themingElement) => this.renderer.removeChild(document.head, themingElement));
            const themingStyleUrls = this.supportedThemes.get(theme);
            return forkJoin(themingStyleUrls.map((url) => {
                const link = this.renderer.createElement('link');
                this.renderer.setAttribute(link, 'rel', 'stylesheet');
                this.renderer.setAttribute(link, 'id', 'theme-css');
                this.renderer.setAttribute(link, 'type', 'text/css');
                this.renderer.setAttribute(link, 'href', url);
                this.renderer.appendChild(document.head, link);
                return fromEvent(link, 'load').pipe(take(1));
            }));
        }).pipe(finalize(() => {
            // davinci svg elements do not reload css properly
            if (typeof window['forceThemeCheck'] === 'function') {
                window['forceThemeCheck']();
            }
        }), map(() => void 0));
    }
}
ThemingService.KEY_THEME = 'preferredTheme';
ThemingService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ThemingService, deps: [{ token: DOCUMENT }, { token: i0.RendererFactory2 }, { token: APP_BASE_HREF }, { token: i1.Location }], target: i0.ɵɵFactoryTarget.Injectable });
ThemingService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ThemingService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.0", ngImport: i0, type: ThemingService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: Document, decorators: [{
                    type: Inject,
                    args: [DOCUMENT]
                }] }, { type: i0.RendererFactory2 }, { type: undefined, decorators: [{
                    type: Inject,
                    args: [APP_BASE_HREF]
                }] }, { type: i1.Location }]; } });

/**
 * A typical implementation for querying remote resources periodically uses timer/interval + switchMap/mergeMap,
 * however, both switchMap and mergeMap have drawbacks in case the resource takes longer to query than the
 * desired timer period.
 *
 * Let's say you want an update rate of 1s, but it takes 2s for the resource to be fetched. In this case, the timer will
 * trigger faster than your resource is retrieved, so what happens if you pipe switchMap/mergeMap with the resource
 * Observable into that timer?
 * switchMap: Cancels the previous request. If the query consistently takes longer than 1s, you get a cascade of
 * cancels with no actual data.
 * mergeMap: Queues a new query to be executed before all previous finish. Essentially you're spamming the server and
 * may get data out of order depending on how high the variance in resource retrieval is.
 *
 * This class attempts to retrieve the given resource periodically with the following properties:
 * - only have one query pending at a time
 * - don't queue another query before the last one finishes
 *
 * The result is a timer that attempts to respect the desired update period, but is allowed to slack off when the
 * queries don't finish quickly enough.
 */
class BestEffortSingleQueryTimer {
    constructor(source, targetPeriodMs) {
        this.value$ = new Subject();
        this.roundTripData$ = new Subject();
        this.obs$ = defer(() => of(Date.now())).pipe(mergeMap((startTime) => source.pipe(tap$1((value) => this.value$.next(value)), 
        // delayWhen is only executed when there's a value, but we also want to delay on empty
        isEmpty(), delayWhen(() => {
            const roundTripTime = Date.now() - startTime;
            this.roundTripData$.next(roundTripTime);
            const delayTime = targetPeriodMs - roundTripTime;
            return interval(delayTime);
        }))), 
        // hack to ensure that this will never emit
        mergeMap(() => of()), repeat());
    }
    periodicData() {
        // the point of the merge is so that a consumer will also unwittingly subscribe to the observable responsible for managing the delay
        return merge(this.obs$, this.value$);
    }
    movingAverageRoundTripTime() {
        return this.roundTripData$.pipe(scan((acc, cur) => {
            acc.push(cur);
            if (acc.length > BestEffortSingleQueryTimer.MOVING_AVERAGE_WINDOW) {
                acc.shift();
            }
            return acc;
        }, []), map((arr) => arr.reduce((acc, cur) => acc + cur, 0) / arr.length), 
        // without this it takes two iterations before any data is returned in combination with withLatestFrom
        startWith(0));
    }
}
BestEffortSingleQueryTimer.MOVING_AVERAGE_WINDOW = 10;

/**
 * Instance method operators have error dispatching built in, while the standalone operators don't.
 */
class BindingHelper {
    constructor(elRef, functionExecutionService, clearSession$ = new Subject()) {
        this.elRef = elRef;
        this.functionExecutionService = functionExecutionService;
        this.issueStream$ = new Subject();
        this.previousPostProcessedData = undefined;
        this.activeIssues = new Map();
        this.issueStream$.subscribe((issue) => {
            if (!this.customElementContainer) {
                this.customElementContainer = this.elRef.nativeElement.closest('dashboard-builder-custom-element-container');
            }
            const issueKey = `${issue.severity}:${issue.message}`;
            if (issue.resolved) {
                this.activeIssues.delete(issueKey);
            }
            else {
                this.activeIssues.set(issueKey, issue);
            }
            this.elRef.nativeElement.dispatchEvent(new ElementIssueEvent(issue));
        });
        clearSession$.subscribe(() => this.clearAllIssues());
    }
    setValue(property, valueRaw, targetType = 'unknown') {
        const value = maybeConvertValue(valueRaw, targetType);
        const valueType = guessType(value);
        const compatible = areTypesCompatible(valueType, targetType, value);
        this.dispatchError(BindingHelper.ERROR_TYPE, `Data source provided '${valueType}', but element can only display '${targetType}'`, compatible);
        if (compatible) {
            this.elRef.nativeElement.dispatchEvent(new BindingValueChangedEvent({ property, value: value }));
            if (this.elRef.nativeElement.parentElement) {
                this.elRef.nativeElement.parentElement[property] = value;
            }
        }
    }
    dispatchWarning(message, details, resolved = false) {
        this.issueStream$.next({ severity: 'warn', message, details, resolved });
    }
    dispatchError(message, details, resolved = false) {
        this.issueStream$.next({ severity: 'error', message, details, resolved });
    }
    clearAllIssues() {
        if (this.customElementContainer) {
            this.activeIssues.forEach((issue) => {
                this.customElementContainer.dispatchEvent(new ElementIssueEvent({ ...issue, resolved: true }));
            });
        }
    }
    /**
     * Useful for continuously polling a resource. The operator will attempt to poll the upstream observable with the
     * provided interval, and dispatch a warning if it doesn't manage to keep up.
     *
     * Errors will be propagated downstream.
     *
     * @param intervalMs - the goal interval for polling
     */
    poll(intervalMs) {
        return (source$) => {
            const bt = new BestEffortSingleQueryTimer(source$, intervalMs);
            return bt.periodicData().pipe(withLatestFrom(bt.movingAverageRoundTripTime()), tap$1(([, avgRtt]) => this.dispatchWarning(BindingHelper.WARN_UPDATE_PERIOD, `Desired: ${intervalMs}ms, actual: ${Math.floor(avgRtt)}ms`, avgRtt <= intervalMs)), map(([data]) => data));
        };
    }
    /**
     * Returns a deserialized JSON value (object, array, or primitive) on success or EMPTY if the parsing fails.
     *
     * Errors will not be propagated downstream.
     */
    parseJson() {
        const op = (source$) => source$.pipe(map((data) => {
            try {
                return JSON.parse(data);
            }
            catch (e) {
                if (typeof data === 'string') {
                    return data;
                }
                throw e;
            }
        }), this.catchErrorAndDispatch(BindingHelper.ERROR_JSON));
        return isolateErrors(op);
    }
    /**
     * Returns a sub-object selected via the selector, or EMPTY if the selector is not valid for that object
     *
     * Errors will not be propagated downstream.
     *
     * @param selector - a series of property names separated by the separator
     * @param separator - property separator ('.' by default)
     * @param errorMessage - the error message to dispatch in case the selector points to undefined data
     */
    selectInJson(selector, separator = '.', errorMessage = BindingHelper.ERROR_SELECTOR) {
        if (!selector) {
            return (source$) => source$;
        }
        const op = (source$) => source$.pipe(map((data) => selector.split(separator).reduce((acc, curr) => (acc ? acc[curr] : undefined), data)), tap$1((data) => {
            if (data === undefined) {
                throw new Error();
            }
        }), this.catchErrorAndDispatch(errorMessage));
        return isolateErrors(op);
    }
    /**
     * Will apply a function on each emission, or return EMPTY if function invocation fails for any reason.
     * The function will be passed the flow's emission, as well as the previous result of the function invocation.
     *
     * Errors will not be propagated downstream.
     *
     * @param fun - function as string
     */
    applyPostProcessor(fun) {
        if (!fun) {
            return (source$) => defer(() => {
                this.dispatchError(BindingHelper.ERROR_FUNCTION_SYNTAX, undefined, true);
                this.dispatchError(BindingHelper.ERROR_FUNCTION_RUNTIME, undefined, true);
                return source$;
            });
        }
        const op = (source$) => this.functionExecutionService.isValid(fun).pipe(switchMap$1((isValid) => {
            this.dispatchError(BindingHelper.ERROR_FUNCTION_SYNTAX, undefined, isValid);
            if (!isValid) {
                return EMPTY;
            }
            return source$.pipe(switchMap$1((data) => this.functionExecutionService.run(fun, data, this.previousPostProcessedData)), tap$1((postProcessedData) => (this.previousPostProcessedData = postProcessedData)), this.catchErrorAndDispatch(BindingHelper.ERROR_FUNCTION_RUNTIME, true));
        }));
        return isolateErrors(op);
    }
    /**
     * On error dispatches message, and resolves it if data was received + no error was thrown
     *
     * @param message - message to dispatch/resolve
     * @param showDetails - show error message in details (true/false)
     */
    catchErrorAndDispatch(message, showDetails = false) {
        return snatchError((err) => this.dispatchError(message, showDetails && err.message ? `Error message: ${err.message}` : undefined), () => this.dispatchError(message, undefined, true));
    }
}
BindingHelper.ERROR_FUNCTION_SYNTAX = 'The post processor function you entered is not valid.\n\nPlease make sure there are no typos or JavaScript syntax errors.';
BindingHelper.ERROR_FUNCTION_RUNTIME = 'A Runtime error occurred. Please check and adapt the post processor function.';
BindingHelper.ERROR_SELECTOR = 'Data could not be retrieved.\n' +
    '\n' +
    'The structure of the data retrieved has changed. Please contact the admin of this data source or select something else.';
BindingHelper.ERROR_JSON = `Unsuitable data format. Please make sure the provided data format is JSON.`;
BindingHelper.ERROR_TYPE = `The data type does not match the selected element.`;
BindingHelper.WARN_UPDATE_PERIOD = 'Unable to retrieve data at the specified rate.';
/**
 * On error calls the provided callback and sends an EMPTY downstream, and if no error was caught then onSuccess is called
 *
 * @param onError - called when an error occurs
 * @param onSuccess - called when there was no error to catch
 */
function snatchError(onError, onSuccess) {
    return (source$) => source$.pipe(catchError((e) => {
        onError(e);
        return EMPTY;
    }), tap$1(() => onSuccess()));
}
/**
 * Be aware that when using this
 * 1. the subscription's error handler will never be called if the error occurs before this operator.
 * 2. no operators after this one are called if the flow keeps causing errors.
 *
 * @param delayMs - delay between retry attempts in ms
 */
function retryWithDelay(delayMs) {
    return (source$) => source$.pipe(retryWhen((errors) => errors.pipe(delay(delayMs))));
}
/**
 * When using this, there are two effects wrt errors
 * 1. errors occurring from outside this operator aren't processed here
 * 2. errors occurring as a result of the given operator aren't propagated to the original observable's error handler.
 * Requires that operators do their own error handling.
 * The point of this is to create resilient flows that can recover from errors.
 *
 * Drawback: No state is transferred between operator invocations (i.e. scan, reduce, etc don't work)
 *
 * @param op - the operator to isolate errors of
 * @returns operator which wraps the provided operator
 */
function isolateErrors(op) {
    return (source$) => source$.pipe(switchMap$1((data) => of(data).pipe(op, catchError(() => EMPTY))));
}

const permissionOrder = [DashboardPermission.Read, DashboardPermission.Write, DashboardPermission.Admin].reduce((acc, item, index) => {
    acc[item] = index;
    return acc;
}, {});
function hasPermission({ actualLevel, minLevel, }) {
    return permissionOrder[actualLevel] >= permissionOrder[minLevel];
}

function getParsedUrl(urlInput, allowRelative = false) {
    try {
        return new URL(urlInput, allowRelative ? window.location.origin : undefined);
    }
    catch (e) {
        return undefined;
    }
}

var ProgressState;
(function (ProgressState) {
    ProgressState["InProgress"] = "inProgress";
    ProgressState["Done"] = "done";
    ProgressState["Error"] = "error";
})(ProgressState || (ProgressState = {}));
function withProgress(multiValue = false) {
    return (source$) => {
        let lastData = undefined;
        let endedWithError = false;
        return source$.pipe(map((data) => {
            lastData = data;
            return { data, state: multiValue ? ProgressState.InProgress : ProgressState.Done };
        }), catchError((error) => {
            endedWithError = true;
            return of({ error, data: lastData, state: ProgressState.Error });
        }), startWith({ state: ProgressState.InProgress }), concatWith(defer(() => (multiValue && !endedWithError ? of({ data: lastData, state: ProgressState.Done }) : EMPTY))), finalize(() => (lastData = undefined)));
    };
}

/**
 * Generated bundle index. Do not edit.
 */

export { BadgeComponent, BestEffortSingleQueryTimer, BindingExecutionResultComponent, BindingHelper, BindingStateComponent, DashboardBuilderCoreModule, DblTapDirective, DropDownSearchableComponent, EdgeScrollDirective, ElementDefinitionService, ElementPropertyLinkingDirective, FunctionExecutionService, GridTileComponent, HelpStateComponent, IMAGE_MAX_MB, ImageSelectComponent, ImageViewComponent, NotificationService, NumericFieldValueDirective, ProgressState, SpecializedBindingPropertiesComponent, SpecializedElementPropertiesComponent, ThemingService, UserInputComponent, areTypesCompatible, getBase64ImageData, getBase64ImageDataSize, getElementPropertyType, getParsedUrl, guessType, hasPermission, isValidBase64ImageData, isolateErrors, maybeConvertValue, renderListItem, retryWithDelay, snatchError, withProgress };
